import type { AccountDrawerProps } from './components/account-drawer';

import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export const _account = (t: (key: string) => string): AccountDrawerProps['data'] => [
  { label: t('account.home'), href: '/', icon: <Iconify icon="solar:home-angle-bold-duotone" /> },
  {
    label: t('account.kycStatus'),
    href: paths.dashboard.artham.kyc.root,
    icon: <Iconify icon="solar:shield-check-bold-duotone" />,
  },
];
